import ScrollLeft from '../assets/scroll-left.svg'
import ScrollRight from '../assets/scroll-right.svg'

export function Pagination({
  currentPage,
  totalPages,
  totalItems,
  pageSize = 10,
  setCurrentPage,
}) {
  const generatePageNumbers = () => {
    const pageNumbers = []
    const maxPagesToShow = 3

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i)
      }
    } else {
      let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2))
      const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1)

      if (endPage - startPage + 1 < maxPagesToShow) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1)
      }

      if (startPage > 1) {
        pageNumbers.push(1, '...')
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i)
      }

      if (endPage < totalPages) {
        pageNumbers.push('...', totalPages)
      }
    }

    return pageNumbers
  }

  const handlePageClick = (pageNumber) => {
    if (typeof pageNumber === 'number') {
      setCurrentPage(pageNumber)
      window.scrollTo(0, 0)
    }
  }

  if (totalItems === 0) return <></>

  const pageNumbers = generatePageNumbers()

  return (
    <div className="flex justify-end pt-7 pb-12">
      {pageNumbers.length > 1 && (
        <div className="flex items-center">
          <button
            onClick={() => handlePageClick(currentPage - 1)}
            className="pagination-nav hover:bg-slate-100 disabled:opacity-50 disabled:hover:bg-transparent focus:outline-none focus:ring-2 focus:ring-blue-500/30 rounded-l border border-slate-300 bg-white"
            disabled={currentPage === 1}
          >
            <img src={ScrollLeft} alt="" />
          </button>
          <div className="flex">
            {pageNumbers.map((pageNumber, index) => (
              <button
                key={index}
                onClick={() => handlePageClick(pageNumber)}
                className={`pagination-page py-[7px] px-[10px] text-xs border border-slate-300 border-l-0 first:border-l focus:outline-none focus:ring-2 focus:ring-blue-500/30
                ${
                  pageNumber === currentPage
                    ? 'bg-blue-600 text-white border-blue-600 font-semibold'
                    : 'bg-white text-slate-700 hover:bg-slate-50'
                }`}
                disabled={pageNumber === '...'}
              >
                {pageNumber}
              </button>
            ))}
          </div>
          <button
            onClick={() => handlePageClick(currentPage + 1)}
            className="pagination-nav hover:bg-slate-100 disabled:opacity-50 disabled:hover:bg-transparent focus:outline-none focus:ring-2 focus:ring-blue-500/30 rounded-r border border-slate-300 border-l-0 bg-white"
            disabled={currentPage === totalPages}
          >
            <img src={ScrollRight} alt="" />
          </button>
        </div>
      )}
    </div>
  )
}

export default Pagination
